<template>
<div v-if="isShow" class="wrapper bg_white pl15 pr15 pt15">
  <router-link v-for="(value, index) in summitMemberList" class="card" :to="{ name: 'fanClubSummitMember', query: { id: value.id } }" :key="value.id">
    <div class="card_image"><img v-on:error="imgLoad" :data-imgSrc="value.imageSrc" :id="'cardImage' + index" :src="value.imageSrc" alt=""></div>
    <div class="title_wrap">
      <h2 class="card_title ar">{{ value.title }}</h2>
    </div>
  </router-link>
</div>
<div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
</template>
<script>
import Config from '@/config/config'
import Summit from '@/components/api/summit'
import checkImg from '@/model/imgLoad'
import Check from '@/model/getToken'

export default {
  data() {
    return {
      isShow: true,
      summitMemberList: [],
    }
  },
  methods: {
    imgLoad(e) {
      // console.log(e.target.dataset.imgsrc);
      // imageSrc, n
      // console.log(e.path[0].attributes[1].nodeValue);
      let res = checkImg.checkImgSrc(e.target.dataset.imgsrc);
      console.log(res);
      e.target.src = res;
    },
    async apiGetSummitMemberList() {
      await Summit.getList().then((val) => {
        this.summitMemberList.push(...val);
      });
    }
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    console.log(res);
    if(res) {
      // API追加後に記述
      await this.apiGetSummitMemberList();
    } else {
      this.isShow = false;
    }

  }
}
</script>

<style lang="css" scoped>
.wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.card {
  box-shadow: 0px 0 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  margin-bottom: 15px;
  overflow: hidden;
  width: 47.5%;
}
.card_image {
  display: block;
  position: relative;
}

.card_image::before {
  content: "";
  display: block;
  padding-top: 75%;
}

.card_image img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.title_wrap {
  padding: 5px 5px 15px;
}
.card_title {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/fanClub/summitMember/SummitMemberList.vue